import type { FC } from 'react'

import { FilterTabs } from '@skytech/ui/FilterTabs'
import { getEntries, getWhiteLabelForDealerStyle } from '@skytech/utils'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import type { TradeInOrderCounter } from '../resources'

export const StatusTabs: FC<{ orderCounter: TradeInOrderCounter }> = ({ orderCounter }) => {
  const { whiteLabel } = useAppContext()
  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status', 'PRICE_REQUEST')
  const whiteLabelForDealerStyle = getWhiteLabelForDealerStyle(whiteLabel)

  return (
    <FilterTabs className="hidden overflow-x-auto md:flex">
      {getEntries(orderCounter).map(([orderStatus, counter]) => (
        <FilterTabs.Button
          className="flex items-center justify-center gap-1 whitespace-normal break-words"
          whiteLabel={whiteLabelForDealerStyle}
          filterName={<Translation id={`trade_in_order_status/${orderStatus}`} />}
          isSelected={orderStatus === queryStatus}
          counter={counter}
          key={orderStatus}
          onClick={() => setQueryStatus(orderStatus)}
        />
      ))}
    </FilterTabs>
  )
}
